import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Icon, InputCheckbox, InputText, Label, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import InputTextControl from "~/components/InputTextControl";
import InputTextAreaControl from "~/components/InputTextAreaControl";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Authorities = styled.div`
  flex-grow: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  min-height: 400px;
`;
const RoleForm = _ref => {
  let {
    authorities,
    control,
    watch,
    setValue
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  let tempAuthorities = authorities;
  const [search, setSearch] = useState("");
  if (search) {
    tempAuthorities = authorities.filter(authority => authority.includes(search));
  }
  const groupedAuthorities = tempAuthorities ? tempAuthorities.reduce((groups, authority) => {
    const prevGroups = groups;
    const [mainPart] = authority.split(".");
    const [levels] = mainPart.split(":");
    const [primary] = levels.split("/");
    if (!prevGroups[primary]) {
      prevGroups[primary] = [];
    }
    groups[primary].push(authority);
    return prevGroups;
  }, {}) : {};
  const handleChange = authority => {
    const selected = watch("authorities");
    if (selected.includes(authority)) {
      setValue("authorities", selected.filter(item => item !== authority));
    } else {
      setValue("authorities", [...selected, authority]);
    }
  };
  const handleChangeGroup = key => {
    const selected = watch("authorities");
    const filtered = selected.filter(item => !item.startsWith(key));
    const selectedAll = watch("authorities").sort().join().includes(groupedAuthorities[key].join());
    if (selectedAll) {
      setValue("authorities", filtered);
    } else {
      setValue("authorities", [...filtered, ...authorities.filter(item => item.startsWith(key))]);
    }
  };
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 5,
    template: "2fr 1fr",
    equal: true
  }, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "name",
    label: t("RoleForm.name"),
    control: control,
    s: {
      mb: 3
    },
    required: true
  }), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "weight",
    label: t("RoleForm.weight"),
    type: "number",
    s: {
      mb: 3
    },
    control: control,
    required: true
  })), /*#__PURE__*/React.createElement(InputTextAreaControl, {
    name: "description",
    rows: 3,
    label: t("RoleForm.description"),
    s: {
      mb: 3
    },
    control: control
  }), /*#__PURE__*/React.createElement(Label, {
    s: {
      mb: 2
    },
    required: true
  }, t("RoleForm.authorities")), /*#__PURE__*/React.createElement(InputText, {
    value: search,
    placeholder: t("RoleForm.search"),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      color: colors.text.secondary,
      src: "search",
      s: {
        mr: 2
      }
    }),
    color: "transparent",
    onChange: value => setSearch(value),
    s: {
      mb: 3
    },
    clearButton: true
  }), /*#__PURE__*/React.createElement(Authorities, null, Object.keys(groupedAuthorities).map(key => /*#__PURE__*/React.createElement(React.Fragment, {
    key: key
  }, /*#__PURE__*/React.createElement(InputCheckbox, {
    value: watch("authorities").sort().join().includes(groupedAuthorities[key].join()),
    onChange: () => handleChangeGroup(key),
    label: /*#__PURE__*/React.createElement(Text, {
      element: "h3"
    }, key)
  }), groupedAuthorities[key].map(authority => /*#__PURE__*/React.createElement(InputCheckbox, {
    key: authority,
    value: watch("authorities").includes(authority),
    onChange: () => handleChange(authority),
    label: authority,
    s: {
      ml: 5
    }
  }))))));
};
export default RoleForm;